import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiPageResponse, PageQuery } from '../types/api.types';
import { Transaction } from '../types/transaction.types';

@Injectable({ providedIn: 'root' })
export class TransactionsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.gatewayUrl}/payment/api/transactions`;

  /**
   * Admin paginated list. NOTE: payment-service doesn't wrap in `ApiCollection`,
   * so `status` / `message` are absent — `ApiPageResponse` makes them optional.
   */
  list(query: PageQuery = {}): Observable<ApiPageResponse<Transaction>> {
    return this.http.get<ApiPageResponse<Transaction>>(this.base, {
      params: this.pageParams(query),
    });
  }

  get(id: number): Observable<Transaction> {
    return this.http.get<Transaction>(`${this.base}/${id}`);
  }

  /** Self-service : transactions du user courant — paginé (enveloppe Nawam). */
  listMine(opts: { page?: number; size?: number } = {}): Observable<ApiPageResponse<Transaction>> {
    const params = new HttpParams()
      .set('page', String(opts.page ?? 1))
      .set('size', String(opts.size ?? 10));
    return this.http.get<ApiPageResponse<Transaction>>(`${this.base}/me`, { params });
  }

  // ⚠️ Pas de méthode `bySource` ici (reliquat de fork supprimé, #99) :
  // `GET /payment/api/transactions/by-source` est réservé ROLE_ADMIN /
  // `transaction_list` → 403 pour un owner, et le restera (§2.8.bis).
  // Les transactions d'une facture passent par
  // `InvoicesService.transactions(id)` (relais rental, ownership vérifié).

  private pageParams(query: PageQuery): HttpParams {
    let params = new HttpParams()
      .set('pageable', 'true')
      .set('page', String(query.page ?? 1))
      .set('size', String(query.size ?? 10))
      .set('isDeleted', String(query.isDeleted ?? false));
    if (query.search?.trim()) params = params.set('search', query.search.trim());
    return params;
  }
}
